(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciar = () => {
      document.querySelectorAll('[data-ng-ba]').forEach((raiz) => {
        if (raiz.dataset.ngListo) return;
        raiz.dataset.ngListo = 'true';

        raiz.querySelectorAll('[data-ng-comparador]').forEach((comp) => {
          const rango = comp.querySelector('[data-ng-rango]');
          rango.addEventListener('input', () => comp.style.setProperty('--ng-pos', rango.value + '%'));
        });

        const tabs = Array.from(raiz.querySelectorAll('[data-ng-tab]'));
        const activar = (tab) => {
          tabs.forEach((t) => {
            const activo = t === tab;
            t.setAttribute('aria-selected', activo);
            t.tabIndex = activo ? 0 : -1;
            document.getElementById(t.getAttribute('aria-controls')).hidden = !activo;
          });
        };
        tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => activar(tab));
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            const sig = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
            activar(sig);
            sig.focus();
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-cod-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dinero = (centavos) =>
      '$' + (centavos / 100).toLocaleString('es-EC', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const avisar = (nombre, datos) => {
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish(nombre, datos);
        }
      } catch (e) {
        /* la analítica nunca debe romper el pedido */
      }
      try {
        if (typeof window.fbq === 'function' && (nombre === 'ng_checkout_started' || nombre === 'ng_order_submitted')) {
          const evento = nombre === 'ng_checkout_started' ? 'InitiateCheckout' : 'Purchase';
          window.fbq('track', evento, { value: datos.valor, currency: datos.moneda, contents: datos.contenidos });
        }
      } catch (e) {
        /* idem */
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: nombre, ...datos });
    };

    const iniciar = () => {
      const modal = document.querySelector('[data-ng-cod]');
      if (!modal || modal.dataset.ngListo) return;
      modal.dataset.ngListo = 'true';

      const form = modal.querySelector('[data-ng-cod-form]');
      const enviar = modal.querySelector('[data-ng-cod-enviar]');
      const bump = modal.querySelector('[data-ng-cod-bump]');
      const elSubtotal = modal.querySelector('[data-ng-cod-subtotal]');
      const elTotal = modal.querySelector('[data-ng-cod-total]');
      const ajustes = JSON.parse(modal.dataset.ngAjustes || '{}');
      const salidaCfg = ajustes.salida || {};
      const salida = modal.querySelector('[data-ng-salida]');
      const filaDesc = modal.querySelector('[data-ng-cod-descuento-fila]');
      let abierto = false;
      let extra = 0; // % de descuento extra aceptado en la oferta de salida

      // Quien aceptó la oferta la conserva si reabre el formulario en la misma visita
      try {
        extra = Number(sessionStorage.getItem('ng_salida_aceptada')) || 0;
      } catch (e) {
        /* sin almacenamiento: seguimos sin descuento */
      }

      const ofertaMarcada = () => modal.querySelector('input[name="ng_oferta"]:checked');

      const bruto = () => {
        const o = ofertaMarcada();
        if (!o) return 0;
        let t = Number(o.dataset.precio);
        if (bump && bump.checked) t += Number(bump.dataset.precio);
        return t;
      };
      const descuento = () => Math.round((bruto() * extra) / 100);

      const recalcular = () => {
        if (!ofertaMarcada()) return;
        const total = bruto();
        elSubtotal.textContent = dinero(total);
        if (filaDesc) {
          filaDesc.hidden = !extra;
          if (extra) {
            filaDesc.querySelector('[data-ng-cod-descuento-et]').textContent =
              (salidaCfg.etiqueta || 'Descuento extra') + ' ' + extra + '%';
            filaDesc.querySelector('[data-ng-cod-descuento]').textContent = '-' + dinero(descuento());
          }
        }
        elTotal.textContent = dinero(total - descuento());
      };

      const idVariante = () => {
        const oculto = document.querySelector('#ng-product-form input[name="id"]');
        return oculto ? oculto.value : modal.dataset.ngVariante;
      };

      const contenidos = () => {
        const o = ofertaMarcada();
        const items = [{ id: idVariante(), quantity: Number(o.dataset.cantidad) }];
        if (bump && bump.checked && bump.dataset.variante) {
          items.push({ id: bump.dataset.variante, quantity: 1 });
        }
        return items;
      };

      const valorTotal = () => (bruto() - descuento()) / 100;

      // Toma la oferta del carrito; si el carrito está vacío, la de la página
      const sincronizar = async () => {
        let cantidad = null;
        let totalCarrito = 0;
        try {
          const carrito = await (await fetch('/cart.js')).json();
          const linea = carrito.items.find((i) => String(i.variant_id) === String(idVariante()));
          if (linea) {
            cantidad = linea.quantity;
            totalCarrito = linea.final_line_price;
          }
          if (bump && bump.dataset.variante) {
            bump.checked = carrito.items.some((i) => String(i.variant_id) === bump.dataset.variante);
          }
        } catch (e) {
          /* sin carrito seguimos con lo de la página */
        }
        if (!cantidad) {
          const enPagina =
            document.querySelector('#ng-product-form input[name="quantity"]:checked') ||
            document.querySelector('#ng-product-form input[name="quantity"]');
          if (enPagina) cantidad = Number(enPagina.value);
        }
        // Si la cantidad del carrito no coincide con ningún escalón (p. ej. la
        // clienta puso 5 en el carrito), se muestra tal cual con su precio real.
        const lista = modal.querySelector('[data-ng-cod-ofertas]');
        const suelta = lista.querySelector('[data-ng-cod-suelta]');
        if (suelta) suelta.remove();

        const opciones = [...modal.querySelectorAll('input[name="ng_oferta"]')];
        const exacto = opciones.find((o) => Number(o.dataset.cantidad) === cantidad);

        if (exacto) {
          if (!exacto.disabled) exacto.checked = true;
        } else if (cantidad > 0 && totalCarrito > 0) {
          const li = document.createElement('li');
          li.setAttribute('data-ng-cod-suelta', '');
          li.innerHTML =
            '<label class="ng-cod__oferta">' +
            '<input type="radio" name="ng_oferta" checked' +
            ' value="' + cantidad + '" data-cantidad="' + cantidad + '"' +
            ' data-precio="' + totalCarrito + '"' +
            ' data-titulo="' + cantidad + ' unidades">' +
            '<span class="ng-cod__oferta-img">' +
            (lista.dataset.imgSuelta
              ? '<img src="' + lista.dataset.imgSuelta + '" alt="" loading="lazy">'
              : '') +
            '<span class="ng-cod__oferta-cant">' + cantidad + '</span></span>' +
            '<span class="ng-cod__oferta-datos">' +
            '<span class="ng-cod__oferta-nombre">' + cantidad + ' unidades</span>' +
            '<span class="ng-cod__oferta-precios"><strong>' + dinero(totalCarrito) + '</strong></span>' +
            '</span><span class="ng-cod__radio" aria-hidden="true"></span></label>';
          lista.prepend(li);
        }
        recalcular();
      };

      const abrir = () => {
        if (abierto) return;
        abierto = true;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        sincronizar();
        recalcular();
        arrancarReloj();
        const primero = form.querySelector('input, select');
        if (primero) primero.focus({ preventScroll: true });
        avisar('ng_checkout_started', {
          valor: valorTotal(),
          moneda: ajustes.moneda || 'USD',
          contenidos: contenidos(),
        });
      };

      const cerrar = () => {
        abierto = false;
        modal.hidden = true;
        if (salida) salida.hidden = true;
        document.documentElement.style.overflow = '';
      };

      // --- Oferta de salida ---
      // Por defecto se muestra una sola vez por persona (se recuerda N días en el
      // navegador); con "siempre", cada vez que intenta cerrar sin haberla aceptado.
      const CLAVE_VISTA = 'ng_salida_vista';
      const yaVista = () => {
        try {
          const t = Number(localStorage.getItem(CLAVE_VISTA));
          return t && Date.now() - t < (Number(salidaCfg.dias) || 7) * 864e5;
        } catch (e) {
          return false;
        }
      };
      const puedeOfrecer = () =>
        salida && salidaCfg.activa && !extra && (salidaCfg.frecuencia === 'siempre' || !yaVista());

      const intentarCerrar = () => {
        if (salida && !salida.hidden) {
          rechazarSalida();
          return;
        }
        if (!puedeOfrecer()) {
          cerrar();
          return;
        }
        salida.hidden = false;
        try {
          localStorage.setItem(CLAVE_VISTA, String(Date.now()));
        } catch (e) {
          /* idem */
        }
        salida.querySelector('[data-ng-salida-si]').focus({ preventScroll: true });
        avisar('ng_oferta_salida_vista', { pct: salidaCfg.pct });
      };

      const aceptarSalida = () => {
        extra = Number(salidaCfg.pct) || 10;
        try {
          sessionStorage.setItem('ng_salida_aceptada', String(extra));
        } catch (e) {
          /* idem */
        }
        salida.hidden = true;
        recalcular();
        avisar('ng_oferta_salida_aceptada', { pct: extra });
        const primero = form.querySelector('input, select');
        if (primero) primero.focus({ preventScroll: true });
      };

      const rechazarSalida = () => {
        salida.hidden = true;
        avisar('ng_oferta_salida_rechazada', { pct: salidaCfg.pct });
        cerrar();
      };

      if (salida) {
        salida.querySelector('[data-ng-salida-si]').addEventListener('click', aceptarSalida);
        salida.querySelector('[data-ng-salida-no]').addEventListener('click', rechazarSalida);
      }

      // --- Cuenta regresiva ---
      const reloj = modal.querySelector('[data-ng-cod-reloj]');
      let tic = null;
      const arrancarReloj = () => {
        if (!reloj || tic) return;
        const cont = modal.querySelector('[data-ng-cod-contador]');
        let restante = Number(cont.dataset.minutos) * 60;
        const pintar = () => {
          const m = String(Math.floor(restante / 60)).padStart(2, '0');
          const sg = String(restante % 60).padStart(2, '0');
          reloj.textContent = m + ':' + sg;
          if (restante <= 0) {
            clearInterval(tic);
            tic = null;
          }
          restante -= 1;
        };
        pintar();
        tic = setInterval(pintar, 1000);
      };

      // --- Teléfono con país ---
      const selPais = modal.querySelector('[data-ng-cod-pais]');
      const elCodigo = modal.querySelector('[data-ng-cod-codigo]');
      const paisSel = () => (selPais ? selPais.options[selPais.selectedIndex] : null);
      const codigoPais = () => (selPais ? selPais.value : '+593');
      const esEC = () => (paisSel() ? paisSel().dataset.pais === 'EC' : true);
      // Número nacional sin el 0 inicial (en Ecuador 0991234567 → 991234567)
      const nacional = (v) => (v || '').replace(/[^\d]/g, '').replace(/^0+/, '');
      const telefonoCompleto = () => codigoPais() + nacional(form.querySelector('[name="celular"]').value);
      if (selPais && elCodigo) {
        const pintar = () => {
          const o = paisSel();
          elCodigo.textContent = o ? o.textContent.split(' · ')[0] : codigoPais();
        };
        selPais.addEventListener('change', () => {
          pintar();
          form.querySelectorAll('[name="celular"], [name="celular2"]').forEach((c) => {
            c.closest('.ng-cod__campo').dataset.invalido = 'false';
          });
        });
        pintar();
      }

      // --- Provincia → cantón ---
      const selProv = modal.querySelector('[data-ng-cod-provincia]');
      const selCiudad = modal.querySelector('[data-ng-cod-ciudad]');
      if (selProv && selCiudad) {
        let cantones = {};
        try {
          cantones = JSON.parse(modal.dataset.ngCantones || '{}');
        } catch (e) {
          /* sin datos, el cantón queda libre */
        }
        const marcador = selCiudad.querySelector('option').textContent;
        selProv.addEventListener('change', () => {
          const lista = cantones[selProv.value] || [];
          selCiudad.innerHTML = '';
          const vacio = document.createElement('option');
          vacio.value = '';
          vacio.textContent = lista.length ? marcador : marcador;
          selCiudad.appendChild(vacio);
          lista.forEach((c) => {
            const o = document.createElement('option');
            o.value = c;
            o.textContent = c;
            selCiudad.appendChild(o);
          });
          selCiudad.disabled = !lista.length;
          selCiudad.closest('.ng-cod__campo').dataset.invalido = 'false';
        });
      }

      // --- Validación ---
      const validar = () => {
        let ok = true;
        form.querySelectorAll('input[required], select[required]').forEach((campo) => {
          const caja = campo.closest('.ng-cod__campo');
          const error = caja.querySelector('[data-ng-cod-error]');
          let mensaje = '';
          const valor = campo.value.trim();
          const soloDigitos = valor.replace(/[^\d]/g, '');
          if (!valor) {
            mensaje = ajustes.errorVacio || 'Completa este dato';
          } else if (campo.name === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(valor)) {
            mensaje = ajustes.errorEmail || 'Escribe un correo válido';
          } else if (campo.name === 'celular' || campo.name === 'celular2') {
            const n = nacional(valor);
            // Ecuador: celular de 9 dígitos que empieza en 9 (se escribe 09…). Resto: 6 a 14.
            const ok = esEC() ? /^9\d{8}$/.test(n) : n.length >= 6 && n.length <= 14;
            if (!ok) {
              mensaje = esEC()
                ? ajustes.errorCelular || 'Escribe tu celular como 0991234567'
                : ajustes.errorCelularIntl || 'Escribe tu número sin el código del país';
            } else if (campo.name === 'celular2' && n !== nacional(form.querySelector('[name="celular"]').value)) {
              mensaje = ajustes.errorCelular2 || 'Los dos números no coinciden';
            }
          }
          caja.dataset.invalido = mensaje ? 'true' : 'false';
          if (error) error.textContent = mensaje;
          if (mensaje && ok) {
            campo.focus({ preventScroll: false });
            ok = false;
          }
        });
        return ok;
      };

      // --- Envío del pedido ---
      const mandar = async () => {
        if (!validar()) return;
        enviar.disabled = true;
        const datos = Object.fromEntries(new FormData(form).entries());
        const o = ofertaMarcada();

        const atributos = {
          'Nombre': datos.nombre,
          'Celular': telefonoCompleto(),
          'Dirección': datos.direccion,
          'Referencia': datos.referencia || '-',
          'Provincia': datos.provincia,
          'Ciudad': datos.ciudad,
          'Forma de pago': ajustes.pago || 'Contra entrega',
        };
        if (extra) atributos['Descuento extra'] = extra + '% (oferta de salida) · -' + dinero(descuento());
        if (bump && bump.checked && !bump.dataset.variante) {
          atributos['Adicional'] = ajustes.bumpNombre || 'Oferta adicional';
        }

        try {
          await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: contenidos() }),
          });
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: atributos }),
          });
          fetch('/cart.js')
            .then((r) => r.json())
            .then((c) => pintarBurbuja(c.item_count))
            .catch(() => {});
        } catch (e) {
          /* si falla el carrito seguimos: el pedido se cierra por WhatsApp */
        }

        avisar('ng_order_submitted', {
          valor: valorTotal(),
          moneda: ajustes.moneda || 'USD',
          contenidos: contenidos(),
        });

        if (ajustes.destino === 'checkout') {
          // El pedido se crea en Shopify: así hay número de pedido, página de
          // gracias y Meta recibe la compra con su valor real.
          const partes = (datos.nombre || '').trim().split(/\s+/);
          const nombre = partes.shift() || '';
          const apellido = partes.join(' ') || nombre;
          const q = new URLSearchParams();
          q.set('checkout[email]', datos.email || '');
          q.set('checkout[shipping_address][first_name]', nombre);
          q.set('checkout[shipping_address][last_name]', apellido);
          q.set('checkout[shipping_address][address1]', datos.direccion || '');
          q.set('checkout[shipping_address][address2]', datos.referencia || '');
          q.set('checkout[shipping_address][city]', datos.ciudad || '');
          q.set('checkout[shipping_address][province]', datos.provincia || '');
          q.set('checkout[shipping_address][country]', 'Ecuador');
          q.set('checkout[shipping_address][phone]', telefonoCompleto());
          window.location.href = '/checkout?' + q.toString();
          return;
        }

        const lineas = [
          ajustes.saludo || 'Hola, quiero hacer este pedido:',
          '',
          '• ' + o.dataset.titulo + ' (' + o.dataset.cantidad + ' u.) — ' + dinero(Number(o.dataset.precio)),
        ];
        if (bump && bump.checked) {
          lineas.push('• ' + (ajustes.bumpNombre || 'Oferta adicional') + ' — ' + dinero(Number(bump.dataset.precio)));
        }
        if (extra) {
          lineas.push('• ' + (salidaCfg.etiqueta || 'Descuento extra') + ' ' + extra + '% — -' + dinero(descuento()));
        }
        lineas.push(
          '',
          'Total: ' + dinero(valorTotal() * 100),
          '',
          'Nombre: ' + datos.nombre,
          'Celular: ' + telefonoCompleto(),
          'Provincia: ' + datos.provincia,
          'Ciudad: ' + datos.ciudad,
          'Dirección: ' + datos.direccion
        );
        if (datos.referencia) lineas.push('Referencia: ' + datos.referencia);

        const url = 'https://wa.me/' + (ajustes.whatsapp || '') + '?text=' + encodeURIComponent(lineas.join('\n'));
        window.open(url, '_blank', 'noopener');
        enviar.disabled = false;
        if (ajustes.gracias) window.location.href = ajustes.gracias;
        else cerrar();
      };

      // --- Carrito lateral ---
      // Un solo viaje al servidor: /cart/update.js deja este producto en la
      // cantidad elegida (sin tocar lo demás) y devuelve el carrito lateral ya dibujado
      // (sections). El cajón se abre al instante con "Agregando…" y se llena al
      // llegar la respuesta. Antes eran tres viajes seguidos (vaciar, agregar,
      // pedir el carrito) y en celular tardaba 4–5 s.
      // Fallas cubiertas: toques repetidos, toque en el fondo mientras se abre,
      // señal lenta o caída (15 s por intento + 1 reintento), error del servidor
      // (aviso con "Intentar de nuevo"), algo colgado (seguro a los 25 s) y volver
      // atrás en Safari (bfcache).
      const SECCION = 'cart-drawer-section';
      const BOTONES = '[data-ng-cta], [data-ng-destino-valor], [data-ng-sticky-comprar]';
      const ESPERA_INTENTO = 15000;
      const ESPERA_TOTAL = 25000;
      let enCurso = null;
      let protegerHasta = 0;

      const cajonCarrito = () => document.querySelector('theme-drawer#cart-drawer');

      const marcarCargando = (si) => {
        document.querySelectorAll(BOTONES).forEach((b) => {
          b.classList.toggle('is-cargando', si);
          if (si) b.setAttribute('aria-busy', 'true');
          else b.removeAttribute('aria-busy');
        });
        const cajon = cajonCarrito();
        if (cajon) {
          cajon.classList.toggle('ng-cargando', si);
          if (!si) cajon.classList.remove('ng-lento');
          if (si) cajon.querySelector('.ng-cajon-aviso')?.remove();
        }
      };

      // Mientras carga (y un momento después de abrir), un toque en el fondo
      // oscuro no cierra el carrito: era el segundo toque de la clienta que,
      // con el panel aún deslizándose, contaba como "afuera" y lo cerraba.
      document.addEventListener(
        'click',
        (e) => {
          if (!enCurso && Date.now() > protegerHasta && !cajonCarrito()?.classList.contains('ng-cargando')) return;
          const panel = cajonCarrito()?.querySelector('dialog');
          if (!panel || e.target !== panel) return;
          e.stopPropagation();
          e.preventDefault();
        },
        true
      );

      // Nuestro flujo usa la API /cart/*.js, que no avisa al ícono del header:
      // le pasamos la cantidad nosotros para que el número se vea al instante.
      const pintarBurbuja = (cantidad) => {
        document.querySelectorAll('cart-icon').forEach((icono) => {
          if (typeof icono.renderCartBubble === 'function') icono.renderCartBubble(cantidad);
        });
      };

      const unPedido = async (url, cuerpo) => {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ ...cuerpo, sections: SECCION, sections_url: window.location.pathname }),
        });
        if (!res.ok) {
          const error = new Error('carrito ' + res.status);
          error.estado = res.status;
          try {
            error.detalle = (await res.json()).description;
          } catch (x) {}
          throw error;
        }
        return await res.json();
      };

      // Pedido de respaldo (19-oct-2026): el servidor de Shopify a veces deja un
      // pedido colgado 2–30 s aunque el siguiente responda en 0,3 s. Si a los 3 s no
      // hay respuesta, sale otro igual y se usa el primero que llegue bien. Solo en
      // update.js: fija cantidades, así que dos pedidos iguales dejan el mismo carrito.
      // Ninguno se corta: el evento "agregó al carrito" de los píxeles sale de la
      // respuesta del pedido que de verdad cambió el carrito (el otro dice "sin
      // cambios"); si se cortara el lento, ese evento se perdería.
      const ESPERA_RESPALDO = 3000;
      const pedirCarrito = async (url, cuerpo, intentos = 1) => {
        const repetible = /\/cart\/update\.js/.test(url);
        for (let n = 1; ; n++) {
          let reloj, relojRespaldo;
          try {
            return await new Promise((ok, no) => {
              let vivos = 0;
              let falta = repetible;
              let error;
              const lanzar = () => {
                vivos++;
                unPedido(url, cuerpo).then(ok, (e) => {
                  vivos--;
                  // Un 4xx (p. ej. agotado) es la respuesta real: no se espera al otro
                  if (e.estado && e.estado < 500) return no(e);
                  error = error || e;
                  if (vivos) return;
                  if (!falta) return no(error);
                  // Falló rápido (5xx o señal caída) antes de los 3 s: el respaldo sale ya
                  clearTimeout(relojRespaldo);
                  falta = false;
                  relojRespaldo = setTimeout(lanzar, 400);
                });
              };
              lanzar();
              if (repetible) {
                relojRespaldo = setTimeout(() => {
                  falta = false;
                  lanzar();
                }, ESPERA_RESPALDO);
              }
              reloj = setTimeout(() => no(error || new Error('tiempo')), ESPERA_INTENTO);
            });
          } catch (e) {
            // 4xx no se reintenta; caída de señal o 5xx sí
            if (n >= intentos || (e.estado && e.estado < 500)) throw e;
            await new Promise((r) => setTimeout(r, 700));
          } finally {
            clearTimeout(reloj);
            clearTimeout(relojRespaldo);
          }
        }
      };

      // "Pedir" SUMA: deja este producto con la cantidad elegida en la página y no
      // toca lo demás del carrito (si ya había Melaxin y piden el masajeador,
      // quedan los dos). Antes vaciaba todo lo que no fuera de esta página.
      // regalo / regaloApagado: solo si la página lleva la casilla del complemento
      // (marcada → entra en el mismo viaje; sin marcar → sale). Lo normal es que
      // esa casilla esté solo en el carrito, y entonces aquí no se toca.
      const ponerEnCarrito = async (id, cantidad, regalo = '', regaloApagado = '') => {
        const updates = {};
        if (regaloApagado) updates[regaloApagado] = 0;
        updates[id] = cantidad;
        if (regalo) updates[regalo] = 1;
        // Si tocaron antes de que cargara este JS, ng-head ya mandó el pedido:
        // se usa esa respuesta (si es del mismo producto y cantidad)
        const temprano = window.ngPeticionTemprana;
        window.ngPeticionTemprana = null;
        let carrito = null;
        if (
          temprano &&
          String(temprano.id) === String(id) &&
          temprano.cantidad === cantidad &&
          String(temprano.regalo || '') === String(regalo)
        ) {
          // Si el pedido temprano quedó colgado, no se le espera más de 3 s: se sigue
          // con pedirCarrito (que tiene su propio respaldo)
          const resta = Math.max(0, ESPERA_RESPALDO - (Date.now() - (temprano.t || Date.now())));
          carrito = await Promise.race([temprano.promesa, new Promise((r) => setTimeout(() => r(null), resta))]);
        }
        // update.js solo fija cantidades: repetirlo no duplica, se puede reintentar
        if (!carrito) carrito = await pedirCarrito('/cart/update.js', { updates }, 2);
        const lineas = (carrito.items || []).filter((it) => String(it.variant_id) === String(id));
        const nuestra = lineas.reduce((n, it) => n + it.quantity, 0);
        if (nuestra !== cantidad) {
          if (lineas.length) {
            // El producto está repartido en dos líneas (pasa cuando un descuento usa
            // una de sus unidades): fijar por variante no alcanza, se fija línea por línea
            const porLinea = {};
            lineas.forEach((l, i) => {
              porLinea[l.key] = i === 0 ? cantidad : 0;
            });
            carrito = await pedirCarrito('/cart/update.js', { updates: porLinea }, 2);
          } else {
            await pedirCarrito('/cart/add.js', { items: [{ id: Number(id), quantity: cantidad }] });
            carrito = await pedirCarrito('/cart/update.js', { updates: {} }, 2);
          }
        }
        if (carrito.token) {
          // Foto del carrito para que EasySell no lo vuelva a pedir al abrirse
          // (ver snippets/ng-easysell; se borra sola con cualquier cambio)
          const { sections, ...soloCarrito } = carrito;
          window.ngCarritoFoto = { carrito: soloCarrito, t: Date.now() };
        }
        return carrito;
      };

      // Abre el cajón ya. Si theme-drawer aún no cargó (internet lento), lo espera un poco.
      const abrirCajon = async () => {
        let cajon = cajonCarrito();
        if (cajon && typeof cajon.open !== 'function') {
          await Promise.race([customElements.whenDefined('theme-drawer'), new Promise((r) => setTimeout(r, 4000))]);
          cajon = cajonCarrito();
        }
        if (!cajon || typeof cajon.open !== 'function') return false;
        if (!cajon.isOpen) {
          protegerHasta = Date.now() + 900;
          cajon.open();
        }
        return true;
      };

      // Llena el cajón con el HTML que vino en la respuesta, sin cerrarlo
      const llenarCajon = async (html) => {
        const seccion = document.getElementById('shopify-section-' + SECCION);
        if (!html || !seccion) return;
        const estabaVacio = !!seccion.querySelector('[data-cart-drawer-empty], .cart-drawer--empty');
        try {
          const { morphSection } = await import('@theme/section-renderer');
          await morphSection(SECCION, html, { mode: 'hydration', injectStylesheet: estabaVacio });
        } catch (e) {
          // Respaldo: se reemplaza la sección entera y se vuelve a abrir, pero
          // solo si estaba abierto (si la clienta lo cerró, se respeta)
          const estabaAbierto = !!cajonCarrito()?.isOpen;
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const nuevo = temp.firstElementChild;
          if (nuevo) seccion.replaceWith(nuevo);
          const cajon = cajonCarrito();
          if (estabaAbierto && cajon && typeof cajon.open === 'function' && !cajon.isOpen) cajon.open();
        }
      };

      // Aviso dentro del carrito cuando algo falla, con botón para reintentar
      const avisarError = (texto, boton) => {
        const interior = cajonCarrito()?.querySelector('.cart-drawer__inner');
        if (!interior || !cajonCarrito().isOpen) {
          // Sin carrito lateral a la vista: envío normal del formulario (carrito /cart)
          const f = document.getElementById('ng-product-form');
          if (f) f.submit();
          return;
        }
        interior.querySelector('.ng-cajon-aviso')?.remove();
        const aviso = document.createElement('div');
        aviso.className = 'ng-cajon-aviso';
        aviso.setAttribute('role', 'alert');
        const p = document.createElement('p');
        p.textContent = texto;
        const reintentar = document.createElement('button');
        reintentar.type = 'button';
        reintentar.textContent = 'Intentar de nuevo';
        // Se corta el clic aquí y se reintenta en el siguiente ciclo: si el aviso
        // se borra durante el clic, el cajón lo toma como "clic afuera" y se cierra.
        reintentar.addEventListener('click', (ev) => {
          ev.stopPropagation();
          setTimeout(() => agregarYAbrirCarrito(boton), 0);
        });
        aviso.append(p, reintentar);
        interior.append(aviso);
      };

      const agregarYAbrirCarrito = (boton) => {
        // Toques repetidos mientras trabaja: se ignoran (antes trababan el botón)
        if (enCurso) return enCurso;
        const cantidadEl =
          document.querySelector('#ng-product-form input[name="quantity"]:checked') ||
          document.querySelector('#ng-product-form input[name="quantity"]');
        const id = idVariante();
        if (!id || !cantidadEl) return null;
        const cantidad = Number(cantidadEl.value) || 1;
        // Complemento del carrito (p. ej. el depilador): solo si su casilla está también
        // en la página manda ella; lo normal es que se agregue desde el carrito
        const casillaKit = document.querySelector('#ng-product-form [data-ng-kit-casilla]');
        const regalo = casillaKit && casillaKit.checked ? casillaKit.dataset.variante : '';
        const regaloApagado = casillaKit && !casillaKit.checked ? casillaKit.dataset.variante : '';
        marcarCargando(true);
        const abierto = abrirCajon();
        let terminado = false;
        const trabajo = (async () => {
          const carrito = await ponerEnCarrito(id, cantidad, regalo, regaloApagado);
          if (terminado) return;
          pintarBurbuja(carrito.item_count);
          await llenarCajon(carrito.sections && carrito.sections[SECCION]);
          if (!(await abierto)) window.location.href = '/cart';
        })();
        const seguro = new Promise((_, no) => setTimeout(() => no(new Error('tiempo')), ESPERA_TOTAL));
        const avisoLento = setTimeout(() => cajonCarrito()?.classList.add('ng-lento'), 8000);
        enCurso = Promise.race([trabajo, seguro])
          .catch((e) => {
            terminado = true;
            marcarCargando(false);
            const texto =
              e && e.estado && e.estado < 500 && e.detalle
                ? e.detalle
                : 'No pudimos agregar tu pedido. Revisa tu conexión e inténtalo otra vez.';
            avisarError(texto, boton);
          })
          .finally(() => {
            clearTimeout(avisoLento);
            marcarCargando(false);
            enCurso = null;
          });
        return enCurso;
      };

      // Volver atrás en Safari restaura la página congelada: se limpia el estado
      window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        enCurso = null;
        protegerHasta = 0;
        window.ngPendiente = null;
        marcarCargando(false);
      });

      // Para el aviso temprano de ng-head: si tocaron "Pedir" antes de que cargara
      // este JS, el toque quedó guardado y se hace ahora.
      window.ngCarrito = { agregar: agregarYAbrirCarrito };
      if (window.ngPendiente) {
        const pendiente = window.ngPendiente;
        window.ngPendiente = null;
        agregarYAbrirCarrito(pendiente);
      }

      // --- Enganches ---
      document.addEventListener('click', (e) => {
        // Desde el carrito lateral: abre el formulario
        if (e.target.closest('[data-ng-cod-abrir]')) {
          e.preventDefault();
          const cajon = document.querySelector('theme-drawer#cart-drawer');
          if (cajon && typeof cajon.close === 'function') cajon.close();
          // Con EasySell instalado, su formulario es el checkout: se abre con
          // lo que ya está en el carrito (sin volver a agregar el producto).
          // Se usa su botón "de carrito" (lo inserta EasySell en el carrito
          // lateral, oculto por ng-easysell.css): toma la cantidad del carrito.
          const easysell =
            document.querySelector('.es-popup-button-drawer') || document.getElementById('es-popup-button');
          if (easysell) {
            setTimeout(() => easysell.click(), 250);
            return;
          }
          setTimeout(abrir, 250);
          return;
        }

        // Desde la página de producto: al carrito lateral
        const boton = e.target.closest('[data-ng-cta], [data-ng-destino-valor]');
        if (!boton) return;
        e.preventDefault();
        agregarYAbrirCarrito(boton);
      });

      modal.querySelectorAll('[data-ng-cod-cerrar]').forEach((b) => b.addEventListener('click', intentarCerrar));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && abierto) intentarCerrar();
      });
      modal.addEventListener('change', (e) => {
        if (e.target.name === 'ng_oferta' || e.target.hasAttribute('data-ng-cod-bump')) recalcular();
      });
      enviar.addEventListener('click', mandar);
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        mandar();
      });
      recalcular();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-comparador"] && !Shopify.designMode) return;
  try {
    
  /* Mismo control que el comparador de Problema. La marca ngListo evita que
     se enganche dos veces si los dos scripts corren. */
  (() => {
    const iniciar = () => {
      document.querySelectorAll('[data-ng-comp]').forEach((comp) => {
        if (comp.dataset.ngListo) return;
        comp.dataset.ngListo = 'true';
        const rango = comp.querySelector('[data-ng-comp-rango]');
        if (!rango) return;
        rango.addEventListener('input', () => {
          comp.style.setProperty('--ng-pos', rango.value + '%');
          comp.classList.add('is-tocado');
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-estudio"] && !Shopify.designMode) return;
  try {
    
  /* Un solo observador para todos los anillos: cada uno se llena (por CSS) y
     cuenta su cifra cuando entra en pantalla, y se deja de observar. Los que
     entran en el mismo momento (dos columnas en computadora) salen con un
     pequeño retraso entre sí. */
  (() => {
    const DURACION = 2200;
    const ESPERA = 250;
    const suave = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const contar = (el, retraso) => {
      const fin = Number(el.dataset.ngCifra) || 0;
      const inicio = performance.now() + retraso + ESPERA;
      const paso = (ahora) => {
        const t = Math.max(0, Math.min((ahora - inicio) / DURACION, 1));
        el.textContent = Math.round(fin * (1 - Math.pow(1 - t, 3))) + '%';
        if (t < 1) requestAnimationFrame(paso);
        else el.closest('[data-ng-estudio-item]').classList.add('is-lleno');
      };
      requestAnimationFrame(paso);
    };

    const mostrar = (item, retraso) => {
      if (item.classList.contains('is-visible')) return;
      item.style.setProperty('--ng-retraso', retraso + 'ms');
      item.classList.add('is-visible');
      const cifra = item.querySelector('[data-ng-cifra]');
      if (cifra) contar(cifra, retraso);
    };

    const obs =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entradas) => {
              let n = 0;
              entradas.forEach((e) => {
                if (!e.isIntersecting) return;
                obs.unobserve(e.target);
                mostrar(e.target, n++ * 250);
              });
            },
            { rootMargin: '0px 0px -15% 0px', threshold: 0.6 }
          )
        : null;

    /* Red de seguridad: si el observador no llega a disparar (pasa cuando
       algo de la página bloquea el scroll), esto lo resuelve igual. Se quita
       sola cuando ya no queda ningún anillo por llenar. */
    let pendiente = false;
    const comprobar = () => {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(() => {
        pendiente = false;
        const faltan = document.querySelectorAll('[data-ng-estudio-item]:not(.is-visible)');
        if (!faltan.length) {
          window.removeEventListener('scroll', comprobar);
          return;
        }
        let n = 0;
        faltan.forEach((item) => {
          const r = item.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.85 && r.bottom > 0) {
            if (obs) obs.unobserve(item);
            mostrar(item, n++ * 250);
          }
        });
      });
    };

    const iniciar = () => {
      if (suave()) {
        document.querySelectorAll('[data-ng-estudio]').forEach((s) => s.classList.add('ng-estudio--anim'));
      }
      document.querySelectorAll('[data-ng-estudio-item]').forEach((item) => {
        if (item.dataset.listo) return;
        item.dataset.listo = '1';
        if (obs) obs.observe(item);
        else mostrar(item, 0);
      });
      window.addEventListener('scroll', comprobar, { passive: true });

      /* El video se reproduce solo mientras se ve (mudo, en bucle) y se pausa
         al salir: así no gasta datos si la clienta no llega hasta aquí. */
      document.querySelectorAll('[data-ng-estudio-video]').forEach((video) => {
        if (video.dataset.listo) return;
        video.dataset.listo = '1';
        video.muted = true;
        if (!('IntersectionObserver' in window)) {
          video.play().catch(() => {});
          return;
        }
        new IntersectionObserver(
          ([e]) => {
            if (e.isIntersecting) video.play().catch(() => {});
            else video.pause();
          },
          { threshold: 0.35 }
        ).observe(video);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-luces"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciar = () => {
      document.querySelectorAll('[data-ng-luces-carril]').forEach((carril) => {
        if (carril.dataset.listo) return;
        carril.dataset.listo = '1';

        /* En el celular no hay hover: tocar el carril lo pausa un rato para
           poder leer la tarjeta, y vuelve a andar solo. */
        let reanudar;
        carril.addEventListener('pointerdown', () => {
          carril.classList.add('is-pausa');
          clearTimeout(reanudar);
        });
        const soltar = () => {
          clearTimeout(reanudar);
          reanudar = setTimeout(() => carril.classList.remove('is-pausa'), 2500);
        };
        carril.addEventListener('pointerup', soltar);
        carril.addEventListener('pointercancel', soltar);

        /* Fuera de pantalla no se anima: ahorra batería */
        if ('IntersectionObserver' in window) {
          const pista = carril.querySelector('.ng-luces__pista');
          new IntersectionObserver(([e]) => {
            pista.style.animationPlayState = e.isIntersecting ? '' : 'paused';
          }).observe(carril);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-problem"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciar = () => {
      document.querySelectorAll('[data-ng-comp]').forEach((comp) => {
        if (comp.dataset.ngListo) return;
        comp.dataset.ngListo = 'true';
        const rango = comp.querySelector('[data-ng-comp-rango]');
        rango.addEventListener('input', () => {
          comp.style.setProperty('--ng-pos', rango.value + '%');
          comp.classList.add('is-tocado');
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const avisar = (form) => {
      const marcado =
        form.querySelector('input[name="quantity"]:checked') || form.querySelector('input[name="quantity"]');
      if (!marcado) return;
      // Con el kit de regalo marcado, el precio que se anuncia es el total
      const kit = form.querySelector('[data-ng-kit-casilla]');
      const conKit = !!(kit && kit.checked);
      const totalKit = form.querySelector('[data-ng-kit-total]');
      if (totalKit) totalKit.hidden = !conKit;
      document.dispatchEvent(
        new CustomEvent('ng:variante', {
          detail: { id: marcado.value, precio: (conKit && kit.dataset.precio) || marcado.dataset.precio || '' },
        })
      );
    };

    const iniciarForm = (raiz) => {
      const form = raiz.querySelector('[data-ng-form]');
      if (!form) return;
      const destino = form.querySelector('[data-ng-destino]');
      document.querySelectorAll('[data-ng-destino-valor]').forEach((boton) => {
        boton.addEventListener('click', () => {
          if (destino) destino.value = boton.dataset.ngDestinoValor;
        });
      });
      form.addEventListener('change', (e) => {
        if (e.target.name === 'quantity' || e.target.hasAttribute('data-ng-kit-casilla')) avisar(form);
      });
      avisar(form);
    };

    const iniciarGaleria = (raiz) => {
      const pista = raiz.querySelector('[data-ng-pista]');
      const actual = raiz.querySelector('[data-ng-actual]');
      const total = raiz.querySelector('[data-ng-total]');
      if (!pista || !actual || !total) return;
      const slides = Array.from(pista.children);
      total.textContent = slides.length;
      if (slides.length < 2) {
        actual.closest('p').hidden = true;
        return;
      }
      const minis = Array.from(raiz.querySelectorAll('[data-ng-mini]'));
      const tira = raiz.querySelector('[data-ng-minis]');
      let indice = 0;

      // Fotos 2, 3… (ng-imagen diferida): se activan cuando terminó la primera,
      // cuando la clienta toca la galería o, como muy tarde, al cargar la página.
      const activarFotos = () => {
        pista.querySelectorAll('img[data-ng-srcset]').forEach((img) => {
          img.srcset = img.dataset.ngSrcset;
          img.src = img.dataset.ngSrc;
          img.removeAttribute('data-ng-srcset');
          img.removeAttribute('data-ng-src');
        });
        raiz.querySelectorAll('img[data-ng-mini-src]').forEach((img) => {
          img.src = img.dataset.ngMiniSrc;
          img.removeAttribute('data-ng-mini-src');
        });
      };
      // Tras la primera foto se espera al primer pintado (19-oct-2026): la primera
      // viene precargada y a veces llegaba antes de que la página pintara; las demás
      // le quitaban internet a los estilos (en celular, ~150 KB antes de pintar).
      // requestAnimationFrame no corre mientras los estilos bloquean el pintado.
      const trasPintar = () => requestAnimationFrame(() => requestAnimationFrame(activarFotos));
      const primera = pista.querySelector('img');
      if (!primera || primera.complete) {
        trasPintar();
      } else {
        primera.addEventListener('load', trasPintar, { once: true });
        primera.addEventListener('error', activarFotos, { once: true });
        window.addEventListener('load', activarFotos, { once: true });
        ['pointerdown', 'touchstart', 'scroll', 'focusin'].forEach((ev) =>
          pista.addEventListener(ev, activarFotos, { once: true, passive: true })
        );
        raiz.querySelector('.ng-pm__nav')?.addEventListener('pointerdown', activarFotos, { once: true });
      }

      // Marca la miniatura activa y la mantiene visible dentro de la tira
      const marcar = (i) => {
        indice = i;
        actual.textContent = i + 1;
        minis.forEach((m, n) => {
          if (n === i) m.setAttribute('aria-current', 'true');
          else m.removeAttribute('aria-current');
        });
        const m = minis[i];
        if (tira && m) {
          const izq = m.offsetLeft - tira.offsetLeft;
          const destino = izq - (tira.clientWidth - m.offsetWidth) / 2;
          tira.scrollTo({ left: Math.max(0, destino), behavior: 'smooth' });
        }
      };

      // Las flechas dan la vuelta: después de la última vuelve a la primera
      const ir = (i) => {
        const n = (i + slides.length) % slides.length;
        pista.scrollTo({ left: slides[n].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
        marcar(n);
      };

      const obs = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((en) => {
            if (en.isIntersecting) marcar(slides.indexOf(en.target));
          });
        },
        { root: pista, threshold: 0.6 }
      );
      slides.forEach((s) => obs.observe(s));

      minis.forEach((m) => m.addEventListener('click', () => ir(Number(m.dataset.ngMini))));
      raiz.querySelector('[data-ng-prev]')?.addEventListener('click', () => ir(indice - 1));
      raiz.querySelector('[data-ng-next]')?.addEventListener('click', () => ir(indice + 1));
      pista.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); ir(indice + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); ir(indice - 1); }
      });
    };


    // ¿Cuándo te llega? Fechas con la hora de Ecuador; solo cuentan los días
    // laborables (sin sábados, domingos ni los feriados del ajuste).
    const iniciarEntrega = (raiz) => {
      const caja = raiz.querySelector('[data-ng-entrega]');
      if (!caja) return;
      let hoyTxt;
      try {
        hoyTxt = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Guayaquil', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      } catch (e) {
        return;
      }
      const [y, m, d] = hoyTxt.split('-').map(Number);
      if (!y || !m || !d) return;
      const hoy = new Date(Date.UTC(y, m - 1, d));
      const feriados = new Set((caja.dataset.feriados || '').split(',').map((f) => f.trim()).filter(Boolean));
      const laborable = (f) => {
        const dia = f.getUTCDay();
        return dia !== 0 && dia !== 6 && !feriados.has(f.toISOString().slice(0, 10));
      };
      const sumar = (n) => {
        const f = new Date(hoy);
        let k = 0;
        while (k < n) {
          f.setUTCDate(f.getUTCDate() + 1);
          if (laborable(f)) k++;
        }
        return f;
      };
      const DIAS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
      const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
      const fecha = (f, mes = true) => `${DIAS[f.getUTCDay()]} ${f.getUTCDate()}${mes ? ' ' + MESES[f.getUTCMonth()] : ''}`;
      const num = (v, def) => (Number(v) > 0 ? Number(v) : def);
      const despacho = sumar(num(caja.dataset.despacho, 1));
      const min = sumar(num(caja.dataset.min, 2));
      const max = sumar(num(caja.dataset.max, 4));
      const mismoMes = min.getUTCMonth() === max.getUTCMonth();
      const textos = {
        pedido: fecha(hoy),
        despacho: fecha(despacho),
        llega: `${fecha(min, !mismoMes)} – ${fecha(max)}`,
      };
      caja.querySelectorAll('[data-ng-entrega-fecha]').forEach((el) => {
        const t = textos[el.dataset.ngEntregaFecha];
        if (t) el.textContent = t;
      });
    };

    const iniciar = () => {
      document.querySelectorAll('[data-ng-pm]').forEach((raiz) => {
        if (raiz.dataset.ngListo) return;
        raiz.dataset.ngListo = 'true';
        iniciarForm(raiz);
        iniciarGaleria(raiz);
        iniciarEntrega(raiz);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);

    // Botones verdes "Comprar ahora y pagar al recibir" de toda la página:
    // suben con suavidad hasta las ofertas y las resaltan un momento.
    document.addEventListener('click', (e) => {
      const boton = e.target.closest('[data-ng-subir]');
      if (!boton) return;
      const ofertas = document.querySelector('#ng-product-form .ng-ofertas') || document.getElementById('ng-product-form');
      if (!ofertas) return;
      e.preventDefault();
      // scrollIntoView y no window.scrollTo: en PC Horizon desplaza .page-wrapper,
      // no la ventana. El margen del header sticky lo da scroll-margin-top.
      ofertas.scrollIntoView({ behavior: 'smooth', block: 'start' });
      ofertas.classList.remove('is-resaltado');
      void ofertas.offsetWidth;
      ofertas.classList.add('is-resaltado');
      setTimeout(() => ofertas.classList.remove('is-resaltado'), 2200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciar = () => {
      const barra = document.querySelector('[data-ng-sticky]');
      if (!barra || barra.dataset.ngListo) return;
      barra.dataset.ngListo = 'true';

      const precio = barra.querySelector('[data-ng-sticky-precio]');
      const marcada =
        document.querySelector('#ng-product-form input[name="quantity"]:checked') ||
        document.querySelector('#ng-product-form input[name="quantity"]');
      if (precio && marcada && marcada.dataset.precio) precio.textContent = marcada.dataset.precio;
      const kit = document.querySelector('#ng-product-form [data-ng-kit-casilla]');
      if (precio && kit && kit.checked && kit.dataset.precio) precio.textContent = kit.dataset.precio;
      document.addEventListener('ng:variante', (e) => {
        if (precio && e.detail.precio) precio.textContent = e.detail.precio;
      });

      const comprar = barra.querySelector('[data-ng-sticky-comprar]');
      if (comprar && !comprar.dataset.listo) {
        comprar.dataset.listo = '1';
        comprar.addEventListener('click', () => {
          const real = document.querySelector('#ng-product-form [data-ng-cta]');
          if (real) { real.click(); return; }
          const form = document.getElementById('ng-product-form');
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }

      const principal = document.querySelector('[data-ng-cta-principal]');
      if (!principal) return;

      barra.hidden = false;
      barra.dataset.oculto = 'true';

      // Scroll en fase de captura sobre document: en escritorio la página se
      // desplaza dentro de un contenedor y window no recibe el evento.
      let pendiente = false;
      const actualizar = () => {
        pendiente = false;
        const mostrar = principal.getBoundingClientRect().bottom < 0;
        barra.dataset.oculto = mostrar ? 'false' : 'true';
        const visible = mostrar && getComputedStyle(barra).display !== 'none';
        document.documentElement.classList.toggle('ng-sticky-visible', visible);
      };
      const programar = () => {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(actualizar);
      };
      document.addEventListener('scroll', programar, { passive: true, capture: true });
      window.addEventListener('resize', programar);
      actualizar();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-video-texto"] && !Shopify.designMode) return;
  try {
    
  /* Mismo criterio que el home: iOS necesita muted + playsinline + autoplay
     antes de cargar, y con bajo consumo hay que reintentar al primer toque. */
  (() => {
    const pendientes = new Set();
    const reintentar = () => {
      pendientes.forEach((v) => {
        const p = v.play();
        if (p && p.then) p.then(() => pendientes.delete(v)).catch(() => {});
      });
    };
    ['touchstart', 'pointerdown', 'scroll', 'click'].forEach((ev) =>
      document.addEventListener(ev, reintentar, { passive: true })
    );

    // Elegir calidad y poner fuente/portada: window.ngVideo (snippets/ng-head)
    const cargar = (video) =>
      window.ngVideo.cargar(video, (v) => {
        if (!v.dataset.ngVisible) return;
        const p = v.play();
        if (p && p.catch) p.catch(() => pendientes.add(v));
      });

    const iniciar = () => {
      document.querySelectorAll('[data-ng-vt-video]').forEach((video) => {
        if (video.dataset.ngListo) return;
        video.dataset.ngListo = 'true';
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('autoplay', '');
        video.removeAttribute('loading');

        // Portada y fuente cuando ya está cerca (1200 px antes): así llega con
        // el video empezando a descargar y arranca casi al instante.
        const cerca = new IntersectionObserver(
          ([en]) => {
            if (!en.isIntersecting) return;
            cerca.disconnect();
            cargar(video);
          },
          { rootMargin: '1200px 0px' }
        );
        cerca.observe(video);

        const obs = new IntersectionObserver(
          ([en]) => {
            video.dataset.ngVisible = en.isIntersecting ? '1' : '';
            if (en.isIntersecting) {
              cargar(video);
              const p = video.play();
              if (p && p.catch) p.catch(() => pendientes.add(video));
            } else if (!video.paused) {
              video.pause();
            }
          },
          { threshold: 0.2 }
        );
        obs.observe(video);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();
})();
